function init_news(group_id = null) {
    let $btn = $('#show-more-news');
    if (!$btn.length) return;

    const url = $btn.data('url') || '/news/default/ajax-get-news-cart';
    const step = parseInt($btn.data('step')) || 9;
    const total = parseInt($btn.data('total-news')) || 0;
    const container = $btn.data('container') || '.news-container';

    const initialOffset = parseInt($btn.data('offset')) || step;

    const news = new News(initialOffset, step);

    const ajaxCallback = (response) => {
        if (!response || !response.response) {
            $btn.hide();
            return;
        }

        $(container).append(response.response);

        // Update offset
        const newOffset = news.getOffset() + news.getStep();
        news.setOffset(newOffset);
        $btn.attr('data-offset', newOffset);

        // Hide button if loaded less than step or reached total
        if ((response.count && response.count < news.getStep()) ||
            (total && newOffset >= total)) {
            $btn.hide();
        }
    };

    $btn.on('click', function () {
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                offset: news.getOffset(),
                group_id: group_id,
                _csrf: getCsrfToken()
            },
            success: ajaxCallback,
            error: function () {
                $btn.hide();
            }
        });
    });
}

class News {
    constructor(offset = 9, step = 9) {
        this._offset = offset;
        this._step = step;
    }
    setOffset(offset) { this._offset = offset; }
    getOffset() { return this._offset; }
    getStep() { return this._step; }
}

function getCsrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.getAttribute('content') : '';
}
